import type { AssistantResponse, MountainSeverity, ResponseSource } from "../types/AssistantResponse.js";

export interface ResponseInput {
  readonly message: string;
  readonly severity: MountainSeverity;
  readonly confidence: number;
  readonly dataUsed: readonly string[];
  readonly dataTimestamp: string;
  readonly offline: boolean;
  readonly recommendedAction: string;
  readonly limitations?: readonly string[];
  readonly source: ResponseSource;
}

export class ResponseBuilder {
  static build(input: ResponseInput): AssistantResponse {
    const confidence = Math.min(1, Math.max(0, input.confidence));
    return {
      message: input.message,
      severity: input.severity,
      confidence,
      data_used: [...input.dataUsed],
      data_timestamp: input.dataTimestamp,
      offline: input.offline,
      recommended_action: input.recommendedAction,
      limitations: [...(input.limitations ?? [])],
      source: input.source,
    };
  }
}
